/* eslint-disable */
import { useMemo } from "react";
import { useDictionary, useOLAPTransformer, OLAPTransformerResult, OLAPTransformerOptions } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { Dictionary } from "@sa/rep-mdm";
import { OLAPResult } from "@sa/rep-olap";
import { SLIDE_NUMBER } from "../constants";

const COMMODITIES_AXIS = "commodities.default";
const ROW_AXIS = "sources.default";
const COLUMN_AXIS = "calendar.default";

export function useChartForecastData(olapResult: OLAPResult | null): OLAPTransformerResult | null {
  const [, columnsDict] = useDictionary(dictionaryService, "calendar-origin");
  const [itemsRows, rowsDict] = useDictionary(dictionaryService, "slides-sources");
  const [itemsCommodities, commoditiesDict] = useDictionary(dictionaryService, "slides-commodities");
  const [itemsCommoditiesDisplay] = useDictionary(dictionaryService, "slides-commodities-display", undefined, {
    'slide': SLIDE_NUMBER,
    'business_unit': 1
  });

  const options = useMemo<OLAPTransformerOptions | null>(() => {
    if ([olapResult, columnsDict, rowsDict,commoditiesDict, itemsCommoditiesDisplay, itemsCommodities, itemsRows].some(x => !Boolean(x))) {
      return null;
    }

    return {
      data: olapResult?.data,
      attrsNameProxy: new Map([
        [`${ROW_AXIS}.id`, (id: unknown, lcid: number) => {
          const item = itemsRows?.find(x => String(x.id) === String(id));
          return item?.getValue('identifier');
        }],
        [`${COMMODITIES_AXIS}.name`, (id: unknown, lcid: number) => {
          const itemDisplay = itemsCommoditiesDisplay?.find(x => Number(x.getValue('olap_commodity')) === Number(id));
          const item = itemsCommodities?.find(x => Number(x.id) === Number(id));
          return (itemDisplay || item)?.getValue('name') || { [lcid]: '' } as any;
        }]
      ]),
      attrsDictionaries: new Map([
        [COMMODITIES_AXIS, commoditiesDict],
        [COLUMN_AXIS, columnsDict],
        [ROW_AXIS, rowsDict],
      ]) as ReadonlyMap<string, Dictionary>
    } as OLAPTransformerOptions
  }, [olapResult, columnsDict, rowsDict, commoditiesDict,itemsCommoditiesDisplay, itemsCommodities, itemsRows]);

  const query = useMemo(() => {
    return {
      lcid: 9,
      columns: [`${COLUMN_AXIS}.name`, `${COLUMN_AXIS}.id`],
      rows: [`${ROW_AXIS}.name`, `${ROW_AXIS}.id`, `${COMMODITIES_AXIS}.name`],
      cellData: {
        inCell: ["Measures.value"],
        attributes: [`${COLUMN_AXIS}.name`, `${ROW_AXIS}.name`, `${COLUMN_AXIS}.id`, `${ROW_AXIS}.id`],
      },
    }
  }, []);
  const data = useOLAPTransformer(options, query);
  return data;
}
